import { AxiosError, AxiosResponse } from 'axios';
import { axiosInstance } from '../../config/axiosConfig';
import { endPointUrls } from '../constants/endPoints';
import { IEntitlementResponse, IToken } from '../customSlice/authSlice';

const getAuthTokenFromRefreshToken = (token: IToken): Promise<string> => {
    return axiosInstance
        .post(window._env.REACT_APP_BASE_API_URL + endPointUrls.refreshToken, token)
        .then((res: AxiosResponse<string>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getuserEntitlements = (): Promise<IEntitlementResponse> => {
    return axiosInstance
        .get(endPointUrls.getuserEntitlements)
        .then((res: AxiosResponse<IEntitlementResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
    };


const authServices = {
    getAuthTokenFromRefreshToken,
    getuserEntitlements,
};

export default authServices;
